import _ from 'lodash';

export const getVisits = state => state.get('visits').toJS();
export const hasVisit = state => state.hasIn(['visit', 'trac']); // !_.isEmpty(getVisit(state));
export const getVisit = state => state.get('visit').toJS();
export const getTimeSlots = state => state.get('timeSlots').toJS();
export const getTimeSlotConfig = state => state.get('timeSlotConfig').toJS();
export const getUnitVerification = state => state.get('unitVerification').toJS();
export const getGoods = state => state.getIn(['goods', 'goods']).toJS();
export const getDocs = state => state.getIn(['docs', 'docs']).toJS();